import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import Note from "./Note";
import NewNote from "./NewNote";

class Notes extends React.Component {
    static propTypes = {
        notes: PropTypes.array.isRequired,
        onFavouriteToggle: PropTypes.func.isRequired,
        canCreateNote: PropTypes.bool,
        onNoteCreate: PropTypes.func.isRequired,
        onNoteEdit: PropTypes.func.isRequired,
    };

    render() {
        const {notes, onFavouriteToggle, canCreateNote, onNoteCreate, onNoteEdit, className} = this.props;

        let classes = "box ";
        if (className) {
            classes += className;
        }

        return (
            <div className={classes}>
                <h2 className="mt-3 mb-3 conversation-notes"><FormattedMessage id="conversation.notes" defaultMessage="Notes for this conversation" /></h2>

                {canCreateNote &&
                    <NewNote onCreate={onNoteCreate}/>
                }

                {notes.map(note => (
                    <Note key={"note-" + note.id} note={note} onFavouriteToggle={() => onFavouriteToggle(note)} onEdit={(text) => onNoteEdit(note.id, text)}/>
                ))}

            </div>
        )
    }
}

export default Notes;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/Notes/Notes.jsx